import { Component, Input } from '@angular/core';

import { CaArea, CaGroup } from '../../../core';
import { deleteFocus } from '../../function/delete-focus.function';
import { moveFocusDown, moveFocusUp } from '../../function/move-focus.function';
import { currentState } from '../../state';
import { State } from '../../state.model';

@Component({
    selector: 'cmps-ca-evaluation-focus-actions',
    templateUrl: './focus-actions.component.html',
})
export class FocusActionsComponent {
    @Input()
    group: CaGroup;

    @Input()
    area: CaArea;

    /** @private */
    _state: State;

    constructor() {
        this._state = currentState();
    }

    /** @private */
    _onMoveUpClick(): void {
        moveFocusUp(this.area);
    }

    /** @private */
    _onMoveDownClick(): void {
        moveFocusDown(this.area);
    }

    /** @private */
    _onDeleteClick(): void {
        deleteFocus(this.area);
    }
}
